import qualityOption from '../generic/quality-option';

export default qualityOption({ min: 0, max: 1, step: 0.01 });
